import { render } from "./ReactNative.vue?vue&type=template&id=4702bc6d"
import script from "./ReactNative.vue?vue&type=script&lang=js"
export * from "./ReactNative.vue?vue&type=script&lang=js"

import "./ReactNative.vue?vue&type=style&index=0&id=4702bc6d&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__